/**
 * 위험성 평가의 MRT Columns 정의
 */

import dayjs from "dayjs";
import {
  Box,
  Button,
  Badge,
  Checkbox,
  Chip,
  FormControl,
  InputAdornment,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  TextField,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FONT_PROPS } from "../styles/colors";
import { COLORS } from "../styles/colors";

////////////////////////////////
// 공통
////////////////////////////////

// 직원 Colums 정의
export const employeesColumns = [
  {
    accessorKey: "emp_name",
    header: "성명",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // Cell: ({ row }) => {
    //   const empName = row.original.emp_name;
    //   if (empName !== null) return empName;
    //   const note = row.original.note;
    //   if (!note) return null;
    //   const splitNote = note.split("/");
    //   return splitNote[1] || null;
    // },
  },
  {
    accessorKey: "department_name",
    header: "부서",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.department_name || "-";
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
  {
    accessorKey: "position_name",
    header: "직급",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.position_name || "-";
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
];

////////////////////////////////
// 기준정보관리
////////////////////////////////

// 대상 공정 등록 Columns 정의
export const standardProcessColumns = [
  {
    accessorKey: "process_index",
    header: "No.",
    size: 50,
    maxSize: 70,
    minSize: 50,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //align: 'right',
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //align: 'right',
      //sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableFooterCellProps: {
      align: "center",
      //align: 'right',
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_description",
    header: "공정 내용",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      //align: "center",
      align: "left",
      //sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableBodyCellProps: {
      //align: "center",
      align: "left",
      sx: {
        pl: "9.6px",
        pt: 0,
        pb: 0,
        pr: "9.6px",
        fontSize: 14,
        fontWeight: FONT_PROPS.MEDIUM,
      },
    },
    muiTableFooterCellProps: {
      //align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
];
// 대상 공정 등록 Columns 정의 (관리자 모드 칼럼)
export const standardProcessColumns_admin = [
  {
    accessorKey: "process_index",
    header: "No.",
    size: 50,
    maxSize: 70,
    minSize: 50,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //align: 'right',
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //align: 'right',
      //sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableFooterCellProps: {
      align: "center",
      //align: 'right',
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_description",
    header: "공정 내용",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      //align: "center",
      align: "left",
      //sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableBodyCellProps: {
      //align: "center",
      align: "left",
      sx: {
        pl: "9.6px",
        pt: 0,
        pb: 0,
        pr: "9.6px",
        fontSize: 14,
        fontWeight: FONT_PROPS.MEDIUM,
      },
    },
    muiTableFooterCellProps: {
      //align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "create_date",
    header: "등록일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.create_date;
      return value ? dayjs(value).format("YYYY-MM-DD") : "-";
    },
  },
  {
    accessorKey: "delete_date",
    header: "삭제일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.delete_date;
      return value ? dayjs(value).format("YYYY-MM-DD") : "-";
    },
  },
];

// 대상 기계/기구 정보 Columns 정의
export const standardMachineColumns = [
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_manage_code;
      return value ? value : "-";
    },
  },
  {
    accessorKey: "safe_machine_name",
    header: "기계/기구명",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = `${safeMachineName} (${masterMachineName})`;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "machine_manufacturer",
    header: "제작사",
    //type: "select",
    type: "text",
    size: 50,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_manufacturer;
      return value ? value : "-";
    },
  },
  {
    accessorKey: "machine_model_name",
    header: "모델명",
    type: "text",
    size: 50,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_model_name;
      return value ? value : "-";
    },
  },
  {
    accessorKey: "machine_standard",
    header: "규격",
    type: "text",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_standard;
      return value ? value : "-";
    },
  },
  {
    accessorKey: "machine_purchase_date",
    header: "구입일자",
    type: "date",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_purchase_date;
      return dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD") : "-";
    },
  },
  {
    accessorKey: "machine_age",
    header: "내용연수",
    type: "text",
    size: 50,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_age;
      return value ? value : "-";
    },
  },
  {
    accessorKey: "machine_size",
    header: "Size",
    type: "text",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_size;
      return value ? value : "-";
    },
  },
  {
    accessorKey: "machine_voltage",
    header: "전압",
    type: "text",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.machine_voltage;
      return value ? value : "-";
    },
  },
];

// 위험발생상황 Columns 정의
export const standardSituationColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_cause",
    header: "위험원인",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 350,
    type: "text",
    muiTableHeadCellProps: {
      //align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      // align: "center",
      align: "left",
      sx: {
        pl: "9.6px",
        pt: 0,
        pb: 0,
        pr: "9.6px",
        fontSize: 14,
        fontWeight: FONT_PROPS.MEDIUM,
      },
    },
    muiTableFooterCellProps: {
      // align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
];

// 안전보건법규 Columns 정의
export const standardLawColumns = [
  {
    accessorKey: "law_name",
    header: "법규명",
    type: "text",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "law_active_date",
    header: "시행 일자",
    size: 140,
    type: "date",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const value = row.law_active_date;
      return dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD") : "-";
    },
  },
  {
    accessorKey: "law_url",
    header: "관련 사이트",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row }) => (
      <a
        href={row.original.law_url}
        target="_blank"
        rel="noopener noreferrer"
        className="url_link"
      >
        {row.original.law_url}
      </a>
    ),
  },
  {
    accessorKey: "law_information",
    header: "법규 정보",
    size: 250,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
];

// 안전보건경영 목표 Columns 정의
export const standardGoalColumns = [
  {
    accessorKey: "goal_id",
    header: "No.",
    size: 100,
    //maxSize: 70,
    //minSize: 50,
    muiTableHeadCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "goal_description",
    header: "목표",
    size: 900,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
];

// 안전보건경영 방침 Columns 정의
export const standardCourseColumns = [
  {
    accessorKey: "course_id",
    header: "No.",
    size: 100,
    //maxSize: 70,
    //minSize: 50,
    muiTableHeadCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "course_description",
    header: "방침",
    size: 900,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
];

// 안전보건경영 조직도 설정 Columns 정의
export const standardSafeOrgColumns = [
  {
    accessorKey: "role_name",
    header: "담당",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.safeRoleData.role_name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
  {
    accessorKey: "emp_name",
    header: "성명",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   return row.employeeData.emp_name || '-';
    // },
    // Cell: ({ cell, table }) => {
    //   const text = cell.getValue();
    //   const globalFilter = table.getState().globalFilter || '';
    //   return (
    //     <div>
    //       {/* 검색시 하이라이트 처리 */}
    //       <HighlightedText text={text} globalFilter={globalFilter} />
    //     </div>
    //   )
    // }
    Cell: ({ cell, table, row }) => {
      const employees = row.original.employeeData || [];
      const UNDEFINED = "-";
      return (
        <div>
          {employees.map((emp, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip
                  label={emp.emp_name || UNDEFINED}
                  // isinvisible={true} // 편집 모드에서는 항상 삭제 가능
                  variant="outlined"
                  onDelete={() => {
                    // 데이터 업데이트
                    table.options?.onCustomOptionsEditRow({
                      values: {
                        safeRoleData: row.original.safeRoleData,
                        employeeData: [emp],
                      },
                      row,
                      table,
                    });
                  }}
                  deleteIcon={
                    <Tooltip title="삭제" arrow placement="right">
                      <RemoveCircleIcon />
                    </Tooltip>
                  }
                />
              </Box>
            );
          })}
          {/* {employees.length === 0 && (<span>{UNDEFINED}</span>)}
          {employees.map((emp, index) => {
            return (
              <Box key={index} sx={{ display: 'inline-block', width: '100%', p: 0.75 }}>
                <Chip label={emp.emp_name || UNDEFINED} variant="outlined" />
              </Box>
            )
          })} */}
        </div>
      );
    },
  },
  {
    accessorKey: "department_name",
    header: "부서",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   return row.employeeData.department_name || '-';
    // },
    // Cell: ({ cell, table }) => {
    //   const text = cell.getValue();
    //   const globalFilter = table.getState().globalFilter || '';
    //   return (
    //     <div>
    //       {/* 검색시 하이라이트 처리 */}
    //       <HighlightedText text={text} globalFilter={globalFilter} />
    //     </div>
    //   )
    // }
    Cell: ({ cell, table, row }) => {
      const employees = row.original.employeeData || [];
      const UNDEFINED = "-";
      return (
        <div>
          {employees.length === 0 && <span>{UNDEFINED}</span>}
          {employees.map((emp, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Typography sx={{ fontSize: 14 }}>
                  {emp.department_name || UNDEFINED}
                </Typography>
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "position_name",
    header: "직급",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   return row.employeeData.position_name || '-';
    // },
    // Cell: ({ cell, table }) => {
    //   const text = cell.getValue();
    //   const globalFilter = table.getState().globalFilter || '';
    //   return (
    //     <div>
    //       {/* 검색시 하이라이트 처리 */}
    //       <HighlightedText text={text} globalFilter={globalFilter} />
    //     </div>
    //   )
    // }
    Cell: ({ cell, table, row }) => {
      const employees = row.original.employeeData || [];
      const UNDEFINED = "-";
      return (
        <div>
          {employees.length === 0 && <span>{UNDEFINED}</span>}
          {employees.map((emp, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Typography sx={{ fontSize: 14 }}>
                  {emp.position_name || UNDEFINED}
                </Typography>
              </Box>
            );
          })}
        </div>
      );
    },
  },
];

// 비상사태 시나리오 Columns 정의
export const standardScenarioColumns = [
  {
    accessorKey: "sit_index",
    header: "대응단계",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "sit_response",
    header: "상황대응",
    size: 300,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "supervisor",
    header: "책임자",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      const { supervisor, supervisor_contact } = row;
      return `${supervisor ?? ""}\n ${"연락처: "}${supervisor_contact ?? ""}`;
    },
    Cell: ({ cell, table }) => {
      const text = String(cell.getValue() ?? "").replace(/\r\n/g, "\n");
      const globalFilter = table.getState().globalFilter || "";
      return (
        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          <HighlightedText text={text} globalFilter={globalFilter} />
        </Box>
      );
    },
  },
  {
    accessorKey: "manager",
    header: "담당자", // TODO: 데이터 표시에 연락처도 기입
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      const { manager, manager_contact } = row;
      return `${manager ?? ""}\n ${"연락처: "}${manager_contact ?? ""}`;
    },
    Cell: ({ cell, table }) => {
      const text = String(cell.getValue() ?? "").replace(/\r\n/g, "\n");
      const globalFilter = table.getState().globalFilter || "";
      return (
        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          <HighlightedText text={text} globalFilter={globalFilter} />
        </Box>
      );
    },
  },
  {
    accessorKey: "coop_department",
    header: "협조 부서",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "note",
    header: "비고",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
];

// 안전보건관리체계 조직 역할 Columns 정의
export const standardSafeRoleManagementColumns = [
  {
    accessorKey: "ohs_role",
    header: "구분",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      //sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table }) => {
      const text = String(cell.getValue() ?? "").replace(/\r\n/g, "\n");
      const globalFilter = table.getState().globalFilter || "";
      return (
        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          <HighlightedText text={text} globalFilter={globalFilter} />
        </Box>
      );
    },
  },
  {
    accessorKey: "ohs_comp",
    header: "적용 제조 사업장(상시 근로자 수)",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table }) => {
      const text = String(cell.getValue() ?? "").replace(/\r\n/g, "\n");
      const globalFilter = table.getState().globalFilter || "";
      return (
        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          <HighlightedText text={text} globalFilter={globalFilter} />
        </Box>
      );
    },
  },
  {
    accessorKey: "ohs_app",
    header: "선임대상 및 자격",
    size: 300,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table }) => {
      const text = String(cell.getValue() ?? "").replace(/\r\n/g, "\n");
      const globalFilter = table.getState().globalFilter || "";
      return (
        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          <HighlightedText text={text} globalFilter={globalFilter} />
        </Box>
      );
    },
  },
  {
    accessorKey: "ohs_duty",
    header: "주요 업무",
    size: 500,
    muiTableHeadCellProps: {
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        pl: "9.6px",
        pt: 0,
        pb: 0,
        pr: "9.6px",
        fontSize: 14,
        fontWeight: FONT_PROPS.MEDIUM,
      },
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table }) => {
      const text = String(cell.getValue() ?? "").replace(/\r\n/g, "\n");
      const globalFilter = table.getState().globalFilter || "";
      return (
        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          <HighlightedText text={text} globalFilter={globalFilter} />
        </Box>
      );
    },
  },
];

// 직원 정보 Columns 정의
export const standardEmployeeColumns = [
  {
    accessorKey: "emp_name",
    header: "성명",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "department_name",
    header: "부서",
    size: 80,
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   const masterMachineName = row.registerAssetData.machine_name;
    //   const safeMachineName = row.registerAssetData.safe_machine_name;
    //   const name = safeMachineName && safeMachineName !== '' ? safeMachineName : masterMachineName;
    //   const processName = row.registerAssetData.process_name;

    //   // ✅ 검색은 이 문자열 기준으로 동작
    //   return `${name} (공정명: ${processName})`;
    // },
    Cell: ({ cell, table }) => {
      const text = cell.getValue() || "-";
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "position_name",
    header: "직급",
    size: 80,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   const masterMachineName = row.registerAssetData.machine_name;
    //   const safeMachineName = row.registerAssetData.safe_machine_name;
    //   const name = safeMachineName && safeMachineName !== '' ? safeMachineName : masterMachineName;
    //   const processName = row.registerAssetData.process_name;

    //   // ✅ 검색은 이 문자열 기준으로 동작
    //   return `${name} (공정명: ${processName})`;
    // },
    Cell: ({ cell, table }) => {
      const text = cell.getValue() || "-";
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
];

//----------------------------------------

////////////////////////////////
// 등록관리
////////////////////////////////

// 공정과 기계/기구 매칭 Columns 정의
export const registerMachineColumns_legacy = [
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.processData.process_name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
  {
    accessorKey: "process_description",
    header: "공정 내용",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.processData.process_description;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    size: 500,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const machines = row.original.machineData || [];
      return (
        <div>
          {/* 설비 표시 처리 */}
          {machines.length === 0 && <span>-</span>}
          {machines.map((machine, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={machine.machine_name} variant="outlined" />
              </Box>
            );
          })}
        </div>
      );
    },
  },
];
// 공정과 기계/기구 매칭 Columns 정의 (편집 모드 칼럼)
export const registerMachineColumns_edit_legacy = [
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.processData.process_name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const machines = row.original.machineData || [];
      return (
        <div>
          {/* 설비 표시 처리 */}
          {machines.map((machine, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip
                  label={machine.machine_name}
                  // isinvisible={true} // 편집 모드에서는 항상 삭제 가능
                  variant="outlined"
                  onDelete={() => {
                    // 데이터 업데이트
                    table.options?.onCustomOptionsEditRow({
                      values: {
                        processData: row.original.processData,
                        machineData: [machine],
                      },
                      // values: {
                      //   processId: row.original.processData.process_id,
                      //   machineId: machine.machine_id,
                      // },
                      row,
                      table,
                    });
                  }}
                  deleteIcon={
                    <Tooltip title="삭제" arrow placement="right">
                      <RemoveCircleIcon />
                    </Tooltip>
                  }
                />
              </Box>
            );
          })}
        </div>
      );
    },
  },
];
// 공정과 기계/기구 매칭 Columns 정의 (관리자 모드 칼럼)
export const registerMachineColumns_admin_legacy = [
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.processData.process_name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
  {
    accessorKey: "process_description",
    header: "공정 내용",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.processData.process_description;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return (
        <div>
          {/* 검색시 하이라이트 처리 */}
          <HighlightedText text={text} globalFilter={globalFilter} />
        </div>
      );
    },
  },
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    size: 250,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const machines = row.original.machineData || [];
      return (
        <div>
          {/* 설비 표시 처리 */}
          {machines.length === 0 && <span>-</span>}
          {machines.map((machine, index) => {
            const isDeleted =
              machine.process_status === 1 ||
              machine.register_asset_status === 1;
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip
                  label={machine.machine_name}
                  // isinvisible={true} // 편집 모드에서는 항상 삭제 가능
                  variant="outlined"
                  onDelete={() => {
                    // 데이터 업데이트
                    table.options?.onCustomOptionsEditRow({
                      values: {
                        processData: row.original.processData,
                        machineData: [machine],
                      },
                      // values: {
                      //   processId: row.original.processData.process_id,
                      //   machineId: machine.machine_id,
                      // },
                      row,
                      table,
                    });
                  }}
                  deleteIcon={
                    <Tooltip title="삭제" arrow placement="right">
                      <RemoveCircleIcon />
                    </Tooltip>
                  }
                  sx={{
                    backgroundColor: isDeleted
                      ? deleteBackground.backgroundColor
                      : "transparent",
                    backgroundImage: isDeleted
                      ? deleteBackground.backgroundImage
                      : "none",
                    backgroundSize: isDeleted
                      ? deleteBackground.backgroundSize
                      : "auto",
                  }}
                />
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "register_asset_create_date",
    header: "등록일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //sx: { padding: 0, fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const machines = row.original.machineData || [];
      return (
        <div>
          {/* 등록일자 표시 처리 */}
          {machines.length === 0 && <span>-</span>}
          {machines.map((machine, index) => {
            const formattedDate = machine.register_asset_create_date
              ? dayjs(machine.register_asset_create_date).format("YYYY-MM-DD")
              : "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={formattedDate} />
                {/* <Typography>
                  {formattedDate}
                </Typography> */}
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "register_asset_delete_date",
    header: "삭제일자",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   if(!row.register_asset_delete_date) return '-';

    //   const formattedTime = dayjs(row.register_asset_delete_date).format("YYYY-MM-DD");
    //   return formattedTime;
    // },
    Cell: ({ cell, table, row }) => {
      const machines = row.original.machineData || [];
      return (
        <div>
          {/* 삭제일자 표시 처리 */}
          {machines.length === 0 && <span>-</span>}
          {machines.map((machine, index) => {
            const formattedDate = machine.register_asset_delete_date
              ? dayjs(machine.register_asset_delete_date).format("YYYY-MM-DD")
              : "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={formattedDate} />
                {/* <Typography>
                  {formattedDate}
                </Typography> */}
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "process_delete_date",
    header: "대상 공정 삭제일자",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   if(!row.process_delete_date) return '-';

    //   const formattedTime = dayjs(row.process_delete_date).format("YYYY-MM-DD");
    //   return formattedTime;
    // },
    Cell: ({ cell, table, row }) => {
      const machines = row.original.machineData || [];
      return (
        <div>
          {/* 삭제일자 표시 처리 */}
          {machines.length === 0 && <span>-</span>}
          {machines.map((machine, index) => {
            const formattedDate = machine.process_delete_date
              ? dayjs(machine.process_delete_date).format("YYYY-MM-DD")
              : "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={formattedDate} />
                {/* <Typography>
                  {formattedDate}
                </Typography> */}
              </Box>
            );
          })}
        </div>
      );
    },
  },
];

const registerMachineCenterProps = {
  align: "center",
};

const getRegisterMachineDisplayName = (machine = {}) => {
  const safeName = machine.safe_machine_name;
  const masterName = machine.machine_name;

  if (safeName && masterName && safeName !== masterName) {
    return `${safeName} (${masterName})`;
  }

  return safeName || masterName || "-";
};

const getRegisterMachineProcessList = (row) =>
  Array.isArray(row?.original?.processData) ? row.original.processData : [];

const renderRegisterMachineText = (text, table) => {
  const globalFilter = table.getState().globalFilter || "";
  return <HighlightedText text={text || "-"} globalFilter={globalFilter} />;
};

const getRegisterMachineDeletedSx = (isDeleted) =>
  isDeleted
    ? {
        backgroundColor: deleteBackground.backgroundColor,
        backgroundImage: deleteBackground.backgroundImage,
        backgroundSize: deleteBackground.backgroundSize,
      }
    : undefined;

const renderRegisterProcessChips = ({ row, table, deletable = false, showDeleted = false }) => {
  const processes = getRegisterMachineProcessList(row);

  return (
    <div>
      {processes.length === 0 && <span>-</span>}
      {processes.map((process, index) => {
        const isDeleted =
          showDeleted &&
          (process.process_status === 1 || process.register_asset_status === 1);

        return (
          <Box
            key={`${process.process_id}-${process.register_asset_id || index}`}
            sx={{ display: "inline-block", width: "100%", p: 0.75 }}
          >
            <Chip
              label={process.process_name || "-"}
              variant="outlined"
              onDelete={
                deletable
                  ? () => {
                      table.options?.onCustomOptionsEditRow({
                        values: {
                          machineData: row.original.machineData,
                          processData: [process],
                        },
                        row,
                        table,
                      });
                    }
                  : undefined
              }
              deleteIcon={
                deletable ? (
                  <Tooltip title="삭제" arrow placement="right">
                    <RemoveCircleIcon />
                  </Tooltip>
                ) : undefined
              }
              sx={getRegisterMachineDeletedSx(isDeleted)}
            />
          </Box>
        );
      })}
    </div>
  );
};

const renderRegisterProcessDateChips = (row, field) => {
  const processes = getRegisterMachineProcessList(row);

  return (
    <div>
      {processes.length === 0 && <span>-</span>}
      {processes.map((process, index) => {
        const formattedDate = process[field]
          ? dayjs(process[field]).format("YYYY-MM-DD")
          : "-";

        return (
          <Box
            key={`${process.process_id}-${process.register_asset_id || index}-${field}`}
            sx={{ display: "inline-block", width: "100%", p: 0.75 }}
          >
            <Chip label={formattedDate} />
          </Box>
        );
      })}
    </div>
  );
};

// 공정과 기계/기구 매칭 Columns 정의 (설비 중심)
export const registerMachineColumns = [
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    size: 220,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) => getRegisterMachineDisplayName(row.machineData),
    Cell: ({ cell, table }) => renderRegisterMachineText(cell.getValue(), table),
  },
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    size: 140,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) => row.machineData?.machine_manage_code || "-",
    Cell: ({ cell, table }) => renderRegisterMachineText(cell.getValue(), table),
  },
  {
    accessorKey: "process_names",
    header: "연결 공정",
    size: 420,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) =>
      Array.isArray(row.processData)
        ? row.processData.map((process) => process.process_name).join(" ")
        : "",
    Cell: ({ row, table }) => renderRegisterProcessChips({ row, table }),
  },
];

// 공정과 기계/기구 매칭 Columns 정의 (편집 모드, 설비 중심)
export const registerMachineColumns_edit = [
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    size: 220,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) => getRegisterMachineDisplayName(row.machineData),
    Cell: ({ cell, table }) => renderRegisterMachineText(cell.getValue(), table),
  },
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    size: 140,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) => row.machineData?.machine_manage_code || "-",
    Cell: ({ cell, table }) => renderRegisterMachineText(cell.getValue(), table),
  },
  {
    accessorKey: "process_names",
    header: "연결 공정",
    size: 420,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) =>
      Array.isArray(row.processData)
        ? row.processData.map((process) => process.process_name).join(" ")
        : "",
    Cell: ({ row, table }) =>
      renderRegisterProcessChips({ row, table, deletable: true }),
  },
];

// 공정과 기계/기구 매칭 Columns 정의 (관리자 모드, 설비 중심)
export const registerMachineColumns_admin = [
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    size: 220,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) => getRegisterMachineDisplayName(row.machineData),
    Cell: ({ cell, table }) => renderRegisterMachineText(cell.getValue(), table),
  },
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    size: 140,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) => row.machineData?.machine_manage_code || "-",
    Cell: ({ cell, table }) => renderRegisterMachineText(cell.getValue(), table),
  },
  {
    accessorKey: "process_names",
    header: "연결 공정",
    size: 360,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) =>
      Array.isArray(row.processData)
        ? row.processData.map((process) => process.process_name).join(" ")
        : "",
    Cell: ({ row, table }) =>
      renderRegisterProcessChips({
        row,
        table,
        deletable: true,
        showDeleted: true,
      }),
  },
  {
    accessorKey: "register_asset_create_date",
    header: "등록일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) =>
      Array.isArray(row.processData)
        ? row.processData.map((process) => process.register_asset_create_date || "").join(" ")
        : "",
    Cell: ({ row }) => renderRegisterProcessDateChips(row, "register_asset_create_date"),
  },
  {
    accessorKey: "register_asset_delete_date",
    header: "삭제일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) =>
      Array.isArray(row.processData)
        ? row.processData.map((process) => process.register_asset_delete_date || "").join(" ")
        : "",
    Cell: ({ row }) => renderRegisterProcessDateChips(row, "register_asset_delete_date"),
  },
  {
    accessorKey: "process_delete_date",
    header: "대상 공정 삭제일자",
    size: 140,
    type: "text",
    muiTableHeadCellProps: registerMachineCenterProps,
    muiTableBodyCellProps: registerMachineCenterProps,
    muiTableFooterCellProps: registerMachineCenterProps,
    accessorFn: (row) =>
      Array.isArray(row.processData)
        ? row.processData.map((process) => process.process_delete_date || "").join(" ")
        : "",
    Cell: ({ row }) => renderRegisterProcessDateChips(row, "process_delete_date"),
  },
];

const getRegisterCauseAssetNames = (row) => {
  const asset = row.registerAssetData || {};
  const machineName =
    asset.safe_machine_name || asset.machine_name || "미지정 설비";
  const masterMachineName = asset.machine_name || "";
  const processName = asset.process_name || "미지정 공정";

  return {
    machineName,
    masterMachineName,
    processName,
  };
};

const getRegisterCauseAssetSearchText = (row) => {
  const { machineName, masterMachineName, processName } =
    getRegisterCauseAssetNames(row);
  const hazardTexts = (row.situationData || [])
    .flatMap((situation) => [
      situation.danger_category,
      situation.danger_cause,
      situation.danger_description,
    ])
    .filter(Boolean)
    .join(" ");

  return `${machineName} ${masterMachineName} ${processName} ${hazardTexts}`;
};

const renderRegisterCauseAssetCell = ({ table, row }) => {
  const globalFilter = table.getState().globalFilter || "";
  const { machineName, masterMachineName, processName } =
    getRegisterCauseAssetNames(row.original);
  const group = row.original.machineGroup || {};
  const showMasterName =
    masterMachineName && masterMachineName !== machineName;

  return (
    <Box
      sx={{
        width: "100%",
        py: 0.75,
        px: 0.5,
        textAlign: "left",
        borderTop: group.isFirst ? "1px solid #eef0f6" : "none",
      }}
    >
      <Typography
        component="div"
        sx={{
          fontWeight: FONT_PROPS.SEMIBOLD,
          fontSize: 14,
          color: "#202436",
          lineHeight: 1.35,
        }}
      >
        <HighlightedText text={machineName} globalFilter={globalFilter} />
      </Typography>
      {showMasterName ? (
        <Typography
          component="div"
          sx={{
            mt: 0.25,
            fontSize: 12,
            color: "#7c8190",
            lineHeight: 1.3,
          }}
        >
          <HighlightedText
            text={masterMachineName}
            globalFilter={globalFilter}
          />
        </Typography>
      ) : null}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          mt: 0.75,
          flexWrap: "wrap",
        }}
      >
        <Chip
          size="small"
          label={`공정 ${processName}`}
          sx={{
            height: 24,
            borderRadius: "6px",
            bgcolor: "#f4f5fb",
            color: "#4a5162",
            fontWeight: FONT_PROPS.MEDIUM,
          }}
        />
        {group.rowCount > 1 ? (
          <Chip
            size="small"
            variant="outlined"
            label={`${group.index}/${group.rowCount}`}
            sx={{
              height: 24,
              borderRadius: "6px",
              color: "#6f7484",
              borderColor: "#dde1ee",
              fontWeight: FONT_PROPS.MEDIUM,
            }}
          />
        ) : null}
      </Box>
    </Box>
  );
};

const registerCauseAssetColumnBase = {
  accessorKey: "register_asset_name",
  header: "설비 / 연결 공정",
  type: "text",
  size: 240,
  muiTableHeadCellProps: {
    align: "left",
  },
  muiTableBodyCellProps: {
    align: "left",
  },
  muiTableFooterCellProps: {
    align: "left",
  },
  accessorFn: getRegisterCauseAssetSearchText,
  Cell: renderRegisterCauseAssetCell,
};

// 기계/기구 유해위험요인 등록 Columns 정의
export const registerCauseColumns = [
  registerCauseAssetColumnBase,
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 위험분류 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={situation.danger_category} variant="outlined" />
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "danger_cause",
    header: "위험원인",
    size: 200,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 위험분류 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={situation.danger_cause} variant="outlined" />
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 위험요인 발생상황 및 결과 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={situation.danger_description} variant="outlined" />
              </Box>
            );
          })}
        </div>
      );
    },
  },
];
// 기계/기구 유해위험요인 등록 Columns 정의 (편집 모드 칼럼)
export const registerCauseColumns_edit = [
  registerCauseAssetColumnBase,
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 위험요인 발생상황 및 결과 표시 처리 */}
          {situations.map((situation) => {
            return (
              <Box
                key={situation.danger_cause_id}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip
                  label={situation.danger_description}
                  variant="outlined"
                  onDelete={() => {
                    // 데이터 업데이트
                    table.options?.onCustomOptionsEditRow({
                      values: {
                        registerAssetData: row.original.registerAssetData,
                        situationData: [situation],
                      },
                      // values: {
                      //   registerAssetId: row.original.registerAssetData.register_asset_id,
                      //   dangerCauseId: situation.danger_cause_id,
                      // },
                      row,
                      table,
                    });
                  }}
                  deleteIcon={
                    <Tooltip title="삭제" arrow placement="bottom">
                      <RemoveCircleIcon />
                    </Tooltip>
                  }
                />
              </Box>
            );
          })}
        </div>
      );
    },
  },
];
// 기계/기구 유해위험요인 등록 Columns 정의 (관리자 모드 칼럼)
export const registerCauseColumns_admin = [
  registerCauseAssetColumnBase,
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 위험분류 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={situation.danger_category} variant="outlined" />
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "danger_cause",
    header: "위험원인",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 위험분류 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            return (
              <Box
                key={index}
                sx={{
                  display: "inline-block",
                  width: "100%",
                  height: "100%",
                  p: 0.75,
                }}
              >
                <Chip label={situation.danger_cause} variant="outlined" />
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 350,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 위험요인 발생상황 및 결과 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            const isDeleted =
              situation.process_status === 1 ||
              situation.register_asset_status === 1 ||
              situation.register_cause_status === 1;
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip
                  label={situation.danger_description}
                  variant="outlined"
                  onDelete={() => {
                    // 데이터 업데이트
                    table.options?.onCustomOptionsEditRow({
                      values: {
                        registerAssetData: row.original.registerAssetData,
                        situationData: [situation],
                      },
                      row,
                      table,
                    });
                  }}
                  deleteIcon={
                    <Tooltip title="삭제" arrow placement="right">
                      <RemoveCircleIcon />
                    </Tooltip>
                  }
                  sx={{
                    backgroundColor: isDeleted
                      ? deleteBackground.backgroundColor
                      : "transparent",
                    backgroundImage: isDeleted
                      ? deleteBackground.backgroundImage
                      : "none",
                    backgroundSize: isDeleted
                      ? deleteBackground.backgroundSize
                      : "auto",
                  }}
                />
              </Box>
              // <Box key={index} sx={{ display: 'inline-block', width: '100%', p: 0.75 }}>
              //   <Chip label={situation.danger_description} variant="outlined"/>
              // </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "register_cause_create_date",
    header: "등록일자",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   if(!row.register_cause_delete_date) return '-';

    //   const formattedTime = dayjs(row.register_cause_delete_date).format("YYYY-MM-DD");
    //   return formattedTime;
    // },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 등록일자 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            const formattedDate = situation.register_cause_create_date
              ? dayjs(situation.register_cause_create_date).format("YYYY-MM-DD")
              : "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={formattedDate} />
                {/* <Typography>
                  {formattedDate}
                </Typography> */}
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "register_cause_delete_date",
    header: "삭제일자",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   if(!row.register_cause_delete_date) return '-';

    //   const formattedTime = dayjs(row.register_cause_delete_date).format("YYYY-MM-DD");
    //   return formattedTime;
    // },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 삭제일자 표시 처리 */}
          {situations.length === 0 && <span>-</span>}
          {situations.map((situation, index) => {
            const formattedDate = situation.register_cause_delete_date
              ? dayjs(situation.register_cause_delete_date).format("YYYY-MM-DD")
              : "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={formattedDate} />
                {/* <Typography>
                  {formattedDate}
                </Typography> */}
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "delete_reason",
    header: "삭제사유",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   return row.delete_reason;
    // },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 삭제사유 표시 처리 */}
          {situations.map((situation, index) => {
            const formattedReason = situation.delete_reason || "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                {formattedReason === "-" ? (
                  <Chip label={formattedReason} />
                ) : (
                  <Chip label={formattedReason} variant={"outlined"} />
                )}
              </Box>
              // <div key={index}>
              //   {formattedReason === '-' ? <span>-</span> : (
              //     <div>
              //       <Box key={index} sx={{ display: 'inline-block', width: '100%', p: 0.75 }}>
              //         <Chip label={situation.delete_reason} variant="outlined"/>
              //       </Box>
              //     </div>
              //   )}
              // </div>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "process_delete_date",
    header: "대상 공정 삭제일자",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   if(!row.process_delete_date) return '-';

    //   const formattedTime = dayjs(row.process_delete_date).format("YYYY-MM-DD");
    //   return formattedTime;
    // },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 삭제일자 표시 처리 */}
          {situations.map((situation, index) => {
            const formattedDate = situation.process_delete_date
              ? dayjs(situation.process_delete_date).format("YYYY-MM-DD")
              : "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={formattedDate} />
                {/* <Typography>
                  {formattedDate}
                </Typography> */}
              </Box>
            );
          })}
        </div>
      );
    },
  },
  {
    accessorKey: "register_asset_delete_date",
    header: "공정과 기계/기구 매칭 삭제일자",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    // accessorFn: (row) => { // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
    //   if(!row.register_asset_delete_date) return '-';

    //   const formattedTime = dayjs(row.register_asset_delete_date).format("YYYY-MM-DD");
    //   return formattedTime;
    // },
    Cell: ({ cell, table, row }) => {
      const situations = row.original.situationData || [];
      return (
        <div>
          {/* 삭제일자 표시 처리 */}
          {situations.map((situation, index) => {
            const formattedDate = situation.register_asset_delete_date
              ? dayjs(situation.register_asset_delete_date).format("YYYY-MM-DD")
              : "-";
            return (
              <Box
                key={index}
                sx={{ display: "inline-block", width: "100%", p: 0.75 }}
              >
                <Chip label={formattedDate} />
                {/* <Typography>
                  {formattedDate}
                </Typography> */}
              </Box>
            );
          })}
        </div>
      );
    },
  },
];

// 위험요인등록 현황 Columns 정의
export const registerStatusColumns = [
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_description",
    header: "공정 내용",
    size: 350,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_cause",
    header: "위험원인",
    size: 180,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 450,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";
      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "create_date",
    header: "등록일자",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.register_cause_create_date) return "-";

      const formattedTime = dayjs(row.register_cause_create_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
];
// 위험요인등록 현황 Columns 정의 (전체 항목 표시)
export const registerStatusColumns_all = [
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_description",
    header: "공정 내용",
    size: 350,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_cause",
    header: "위험원인",
    size: 180,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 450,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //align: "left",
      //sx: { pl: '9.6px', pt: 0, pb: 0, pr: '9.6px', fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableFooterCellProps: {
      align: "center",
      //align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "기계/기구명",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "create_date",
    header: "등록일자",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.register_cause_create_date) return "-";

      const formattedTime = dayjs(row.register_cause_create_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
  {
    accessorKey: "delete_date",
    header: "삭제일자",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.register_cause_delete_date) return "-";

      const formattedTime = dayjs(row.register_cause_delete_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
  {
    accessorKey: "delete_reason",
    header: "삭제사유",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      return row.delete_reason;
    },
  },
  {
    accessorKey: "process_delete_date",
    header: "대상 공정 삭제일자",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.process_delete_date) return "-";

      const formattedTime = dayjs(row.process_delete_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "register_asset_delete_date",
    header: "공정과 기계/기구 매칭 삭제일자",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.register_asset_delete_date) return "-";

      const formattedTime = dayjs(row.register_asset_delete_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
];

//----------------------------------------

////////////////////////////////
// 평가관리
////////////////////////////////

// 위험성 수준 평가 Columns 정의
export const assessmentLevelColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 380,
    type: "text",
    muiTableHeadCellProps: {
      // align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      // align: "center",
      align: "left",
      sx: {
        pl: "9.6px",
        pt: 0,
        pb: 0,
        pr: "9.6px",
        fontSize: 14,
        fontWeight: FONT_PROPS.MEDIUM,
      },
    },
    muiTableFooterCellProps: {
      // align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "frequency_level",
    header: "가능성(빈도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        frequencyLevelRoleMapper[row.original.frequency_level];
      const prevValue =
        frequencyLevelRoleMapper[row.original.prev_frequency_level];
      const valueToShow = currentValue || prevValue; // 현재 값이 없으면 이전 값 사용
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(frequencyLevelRoleMapper).includes(
        valueToShow
      )
        ? valueToShow
        : "";
      // 승인된 이후 Select 비활성화
      const isSelectDisabled = row.original.eval_status >= 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseFrequencyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, frequency_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {/* 메뉴아이템 생성(내림차순) */}
            {Object.entries(frequencyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "importancy_level",
    header: "중대성(강도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        importancyLevelRoleMapper[row.original.importancy_level];
      const prevValue =
        importancyLevelRoleMapper[row.original.prev_importancy_level];
      const valueToShow = currentValue || prevValue;
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(importancyLevelRoleMapper).includes(
        valueToShow
      )
        ? valueToShow
        : "";
      // 승인된 이후 Select 비활성화
      const isSelectDisabled = row.original.eval_status >= 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseImportancyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, importancy_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {/* 메뉴아이템 생성(내림차순) */}
            {Object.entries(importancyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "calculate_risk_level",
    header: "위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "prev_calculate_risk_level",
    header: "최신 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.prev_standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.prev_frequency_level *
            row.original.prev_importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "eval_status",
    header: "평가상태",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_status || row.original.eval_status === 0) {
        return evalStatusRoleMapper[0];
      }
      const evalStatus = evalStatusRoleMapper[row.original.eval_status];
      return evalStatus;
    },
  },
];
// 위험성 수준 평가 Columns 정의 (관리자 모드 칼럼)
export const assessmentLevelColumns_admin = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 380,
    type: "text",
    muiTableHeadCellProps: {
      // align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      // align: "center",
      align: "left",
      sx: {
        pl: "9.6px",
        pt: 0,
        pb: 0,
        pr: "9.6px",
        fontSize: 14,
        fontWeight: FONT_PROPS.MEDIUM,
      },
    },
    muiTableFooterCellProps: {
      // align: "center",
      align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "frequency_level",
    header: "가능성(빈도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        frequencyLevelRoleMapper[row.original.frequency_level];
      const prevValue =
        frequencyLevelRoleMapper[row.original.prev_frequency_level];
      const valueToShow = currentValue || prevValue; // 현재 값이 없으면 이전 값 사용
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(frequencyLevelRoleMapper).includes(
        valueToShow
      )
        ? valueToShow
        : "";
      // 승인된 이후 Select 비활성화
      // const isSelectDisabled = row.original.eval_status >= 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            // disabled={isSelectDisabled}
            disabled={!row.original.eval_status} // 평가대기는 선택 불가
            onChange={(e) => {
              const updatedValue =
                reverseFrequencyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, frequency_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {/* 메뉴아이템 생성(내림차순) */}
            {Object.entries(frequencyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "importancy_level",
    header: "중대성(강도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        importancyLevelRoleMapper[row.original.importancy_level];
      const prevValue =
        importancyLevelRoleMapper[row.original.prev_importancy_level];
      const valueToShow = currentValue || prevValue;
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(importancyLevelRoleMapper).includes(
        valueToShow
      )
        ? valueToShow
        : "";
      // 승인된 이후 Select 비활성화
      // const isSelectDisabled = row.original.eval_status >= 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            // disabled={isSelectDisabled}
            disabled={!row.original.eval_status} // 평가대기는 선택 불가
            onChange={(e) => {
              const updatedValue =
                reverseImportancyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, importancy_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {/* 메뉴아이템 생성(내림차순) */}
            {Object.entries(importancyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "calculate_risk_level",
    header: "위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "prev_calculate_risk_level",
    header: "최신 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.prev_standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.prev_frequency_level *
            row.original.prev_importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      return (
        <FormControl size="small" sx={{ width: 155 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label={"입력/수정"}
              disabled={!row.original.eval_status} // 평가대기는 선택 불가
              value={row.original.__eval_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, __eval_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                // field: { clearable: true },
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_status",
    header: "평가상태",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_status || row.original.eval_status === 0) {
        return evalStatusRoleMapper[0];
      }
      const evalStatus = evalStatusRoleMapper[row.original.eval_status];
      return evalStatus;
    },
  },
];

// 위험성 평가 승인 Columns 정의
export const assessmentResultColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //align: "left",
      // sx: { pl: '9.6px', pt: 0, pb: 0, pr: '9.6px', fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableFooterCellProps: {
      align: "center",
      //align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "frequency_level",
    header: "가능성(빈도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        frequencyLevelRoleMapper[row.original.frequency_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(frequencyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      // 승인된 이후 Select 비활성화
      const isSelectDisabled = row.original.eval_status >= 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseFrequencyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, frequency_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {Object.entries(frequencyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "importancy_level",
    header: "중대성(강도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        importancyLevelRoleMapper[row.original.importancy_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(importancyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      // 승인된 이후 Select 비활성화
      const isSelectDisabled = row.original.eval_status >= 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseImportancyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, importancy_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {Object.entries(importancyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "calculate_risk_level",
    header: "위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "requires_improve",
    header: "개선대책",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      const info = row.requires_improve;
      if (info === 1) {
        return "필요";
      } else {
        return "불필요";
      }
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "eval_status",
    header: "평가상태",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_status || row.original.eval_status === 0) {
        return evalStatusRoleMapper[0];
      }
      const evalStatus = evalStatusRoleMapper[row.original.eval_status];
      return evalStatus;
    },
  },
];
// 위험성 평가 승인 Columns 정의 (관리자 모드 칼럼)
export const assessmentResultColumns_admin = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      //align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      //align: "left",
      // sx: { pl: '9.6px', pt: 0, pb: 0, pr: '9.6px', fontSize: 14, fontWeight: FONT_PROPS.MEDIUM },
    },
    muiTableFooterCellProps: {
      align: "center",
      //align: "left",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "frequency_level",
    header: "가능성(빈도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        frequencyLevelRoleMapper[row.original.frequency_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(frequencyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      // 승인 이전 Select 비활성화
      const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseFrequencyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, frequency_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {Object.entries(frequencyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "importancy_level",
    header: "중대성(강도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        importancyLevelRoleMapper[row.original.importancy_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(importancyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      // 승인 이전 Select 비활성화
      const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseImportancyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, importancy_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {Object.entries(importancyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "calculate_risk_level",
    header: "위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "requires_improve",
    header: "개선대책",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      const info = row.requires_improve;
      if (info === 1) {
        return "필요";
      } else {
        return "불필요";
      }
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    }, // row.original.eval_date
    Cell: ({ row, table }) => {
      // 승인 이전 Select 비활성화
      const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: 155 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label={"입력/수정"}
              disabled={isSelectDisabled}
              value={row.original.__eval_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, __eval_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                // field: { clearable: true },
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "approve_date",
    header: "승인일자",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    }, // row.original.eval_date
    Cell: ({ row, table }) => {
      // 승인 이전 Select 비활성화
      const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: 155 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label={"입력/수정"}
              disabled={isSelectDisabled}
              value={row.original.__approve_date}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, __approve_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                // field: { clearable: true },
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_status",
    header: "평가상태",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_status || row.original.eval_status === 0) {
        return evalStatusRoleMapper[0];
      }
      const evalStatus = evalStatusRoleMapper[row.original.eval_status];
      return evalStatus;
    },
  },
];

// 위험성 평가 현황 Columns 정의
export const assessmentStatusColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "frequency_level",
    header: "가능성(빈도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        frequencyLevelRoleMapper[row.original.frequency_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(frequencyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      return (
        <Typography
          sx={{
            fontFamily: FONT_PROPS.PRIMARY,
            fontWeight: FONT_PROPS.MEDIUM,
            color: FONT_PROPS.DARK,
            fontSize: 15,
          }}
        >
          {safeValue}({row.original.frequency_level})
        </Typography>
      );
    },
  },
  {
    accessorKey: "importancy_level",
    header: "중대성(강도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        importancyLevelRoleMapper[row.original.importancy_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(importancyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      return (
        <Typography
          sx={{
            fontFamily: FONT_PROPS.PRIMARY,
            fontWeight: FONT_PROPS.MEDIUM,
            color: FONT_PROPS.DARK,
            fontSize: 15,
          }}
        >
          {safeValue}({row.original.importancy_level})
        </Typography>
      );
    },
  },
  {
    accessorKey: "calculate_risk_level",
    header: "해당월 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "prev_calculate_risk_level",
    header: "전월 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.prev_standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.prev_frequency_level *
            row.original.prev_importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_status",
    header: "평가상태",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_status || row.original.eval_status === 0) {
        return evalStatusRoleMapper[0];
      }
      const evalStatus = evalStatusRoleMapper[row.original.eval_status];
      return evalStatus;
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "approve_date",
    header: "승인일자",
    size: 120,
    type: "text",

    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.approve_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.approve_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.approve_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
];
// 위험성 평가 현황 Columns 정의 (관리자 모드 칼럼)
export const assessmentStatusColumns_admin = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 400,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "frequency_level",
    header: "가능성(빈도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        frequencyLevelRoleMapper[row.original.frequency_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(frequencyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      // 승인 이전 Select 비활성화
      // const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            // disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseFrequencyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, frequency_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {Object.entries(frequencyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "importancy_level",
    header: "중대성(강도)",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue =
        importancyLevelRoleMapper[row.original.importancy_level];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(importancyLevelRoleMapper).includes(
        currentValue
      )
        ? currentValue
        : "";
      // 승인 이전 Select 비활성화
      // const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            // disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseImportancyLevelRoleMapper[e.target.value] || null;
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, importancy_level: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
            }}
          >
            {Object.entries(importancyLevelRoleMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}({key})
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "calculate_risk_level",
    header: "해당월 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "prev_calculate_risk_level",
    header: "전월 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.prev_standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.prev_frequency_level *
            row.original.prev_importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_status",
    header: "평가상태",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_status || row.original.eval_status === 0) {
        return evalStatusRoleMapper[0];
      }
      const evalStatus = evalStatusRoleMapper[row.original.eval_status];
      return evalStatus;
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    }, // row.original.eval_date
    Cell: ({ row, table }) => {
      // 승인 이전 Select 비활성화
      // const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: 155 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label={"입력/수정"}
              // disabled={isSelectDisabled}
              value={row.original.__eval_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, __eval_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                // field: { clearable: true },
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "approve_date",
    header: "승인일자",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    }, // row.original.eval_date
    Cell: ({ row, table }) => {
      // 승인 이전 Select 비활성화
      // const isSelectDisabled = row.original.eval_status < 20;
      return (
        <FormControl size="small" sx={{ width: 155 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label={"입력/수정"}
              // disabled={isSelectDisabled}
              value={row.original.__approve_date}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, __approve_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                // field: { clearable: true },
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
];

// 개선 대책 조회 Columns 정의
export const strategyResultStatusColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 160,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "improve_after_risk",
    header: "개선후 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.improve_after_risk];
      const text = Object.values(riskLevelMapper).includes(currentValue)
        ? currentValue
        : "";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_plan",
    header: "위험성 개선대책 수립",
    size: 160,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "comp_date",
    header: "개선완료일",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.comp_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.comp_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "improve_after",
    header: "개선후 사진",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table, cell }) => {
      const imageUrl = row.original.improve_after || null;
      const imageStatus = "expand_after_image";
      return (
        <Box
          onClick={() => {
            //console.log("사진 클릭:", imageUrl);
            // 데이터 업데이트
            table.options?.onCustomOptionsEditRow({
              values: { ...row.original, imageStatus: imageStatus },
              row,
              table,
            });
          }}
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            width: 80,
            height: 80,
            borderRadius: 2,
            m: 1,
            border: `2px dashed ${COLORS.BORDER_DASH}`,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: COLORS.HOVER_BACKGROUND,
              borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
          }}
        >
          {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 비율 유지하며 채움
                borderRadius: "inherit", // Box의 borderRadius 따라감
              }}
            />
          ) : (
            <>
              <Typography
                sx={{
                  fontFamily: FONT_PROPS.PRIMARY,
                  fontWeight: FONT_PROPS.MEDIUM,
                  color: FONT_PROPS.DARK,
                  fontSize: 15,
                  m: 1,
                }}
              >
                No Image
              </Typography>
            </>
          )}
        </Box>
      );
    },
  },
  {
    accessorKey: "improve_status",
    header: "대책상태",
    size: 90,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.improve_status || row.original.improve_status === 0) {
        return strategyStatusRoleMapper[0];
      }
      const improveStatus =
        strategyStatusRoleMapper[row.original.improve_status];
      return improveStatus;
    },
  },
];

//----------------------------------------

////////////////////////////////
// 대책관리
////////////////////////////////

// 위험성 개선대책 수립 Columns 정의
export const strategyRegisterColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 180,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "current_risk_level",
    header: "현재 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "improve_before",
    header: "개선전 사진",
    size: 80,
    type: "text",
    Cell: ({ row, table, cell }) => {
      const imageUrl = row.original.improve_before || null;

      // 등록완료가 되었다면 이미지 확대 로직, 안되었으면 이미지 추가 로직
      const imageStatus =
        row.original.improve_status >= 10 // 10: 등록완료
          ? ImageRenderState.EXPAND_BEFORE
          : ImageRenderState.BEFORE;
      return (
        <Box
          onClick={() => {
            //console.log("사진 클릭:", imageUrl);
            // 데이터 업데이트
            table.options?.onCustomOptionsEditRow({
              values: { ...row.original, __imageStatus: imageStatus },
              row,
              table,
            });
          }}
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            width: 80,
            height: 80,
            m: 1,
            borderRadius: 2,
            border: `2px dashed ${COLORS.BORDER_DASH}`,
            pointerEvents: "auto", // 클릭 막기
            opacity: 1, // 시각적으로 비활성화 표현
            cursor: "pointer",
            "&:hover": {
              backgroundColor: COLORS.HOVER_BACKGROUND,
              borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
          }}
        >
          {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 비율 유지하며 채움
                borderRadius: "inherit", // Box의 borderRadius 따라감
              }}
            />
          ) : (
            <>
              <AddIcon fontSize="medium" />
              <Typography
                sx={{
                  fontFamily: FONT_PROPS.PRIMARY,
                  fontWeight: FONT_PROPS.MEDIUM,
                  color: FONT_PROPS.DARK,
                  fontSize: 15,
                  m: 1,
                }}
              >
                사진등록
              </Typography>
            </>
          )}
        </Box>
      );
    },
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "improve_plan",
    header: "위험성 개선대책 수립",
    size: 220,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      //console.log("row.original", row.original.improve_plan);
      // 테이블에서 사용할 커스텀 텍스트 필드
      const text = row.original.improve_plan || "";
      // 일정 등록이 된 이후 Select 비활성화
      const isSelectDisabled = row.original.improve_status >= 10; // 10 : 대책 등록완료
      return (
        <FormControl sx={{ width: "100%" }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="입력/수정"
            disabled={isSelectDisabled}
            value={text}
            onChange={(e) => {
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, improve_plan: e.target.value },
                row,
                table,
              });
            }}
            multiline // 여러 줄 입력 가능하게 함
            maxRows={2} // 최대 2줄까지 늘어나게 설정 (2줄 이상은 스크롤)
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 14,
              "& .MuiInputBase-input": {
                textAlign: "center", // 텍스트를 가운데 정렬
              },
            }}
          />
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_after_risk",
    header: "개선 후 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.improve_after_risk];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(riskLevelMapper).includes(currentValue)
        ? currentValue
        : "";
      // 일정 등록이 된 이후 Select 비활성화
      const isSelectDisabled = row.original.improve_status >= 10; // 10 : 대책 등록완료
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isSelectDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseRiskLevelMapper[e.target.value] || null;
              //console.log("개선 후 위험성 standard_id:", updatedValue);
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, improve_after_risk: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
            }}
          >
            {/* 메뉴아이템 생성(내림차순) */}
            {Object.entries(riskLevelMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "expected_date",
    header: "개선 예정일",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 일정 등록이 된 이후 Select 비활성화
      const isSelectDisabled = row.original.improve_status >= 10; // 10 : 대책 등록완료
      return (
        <FormControl size="small" sx={{ width: "155px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              disabled={isSelectDisabled}
              label={"입력/수정"}
              value={row.original.expected_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, expected_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "emp_id",
    header: "담당자",
    size: 115,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      const empName = row.original.emp_name || "";
      // 일정 등록이 된 이후 Select 비활성화
      const isSelectDisabled = row.original.improve_status >= 10; // 10 : 대책 등록완료
      return (
        <OutlinedInput
          disabled={isSelectDisabled}
          value={empName}
          readOnly
          fullWidth={false}
          sx={{
            fontFamily: FONT_PROPS.PRIMARY,
            fontWeight: FONT_PROPS.MEDIUM,
            color: FONT_PROPS.DARK,
            fontSize: 15,
            width: `${(empName.length + 1) * 2}ch`, // ✅ 글자 수 기반 width
            minWidth: "115px", // 너무 작아지는 것 방지
            height: "56px",
            pointerEvents: "none", // 전체 입력 비활성화
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                disabled={isSelectDisabled}
                onClick={() => {
                  //console.log('검색 클릭')
                  // 검색 클릭 시 처리 로직 추가
                  // 예: 검색 모달 열기
                  table.options?.onCustomOptionsEditRow({
                    values: { ...row.original, __hasSearchEmployee: true },
                    row,
                    table,
                  });
                }}
                edge="end"
                sx={{ pointerEvents: "auto" }} // 아이콘만 클릭 가능하게 허용
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      );
    },
  },
  {
    accessorKey: "improve_status",
    header: "대책상태",
    size: 90,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.improve_status || row.original.improve_status === 0) {
        return strategyStatusRoleMapper[0];
      }
      const improveStatus =
        strategyStatusRoleMapper[row.original.improve_status];
      return improveStatus;
    },
  },
];
// 위험성 개선대책 수립 Columns 정의(관리자 모드 칼럼)
export const strategyRegisterColumns_admin = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 180,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "current_risk_level",
    header: "현재 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "improve_before",
    header: "개선전 사진",
    size: 80,
    type: "text",
    Cell: ({ row, table, cell }) => {
      const imageUrl = row.original.improve_before || null;
      const imageStatus = ImageRenderState.BEFORE;
      const isDisabled = !row.original?.improve_status;
      return (
        <Box
          onClick={() => {
            if (isDisabled) return;
            //console.log("사진 클릭:", imageUrl);
            // 데이터 업데이트
            table.options?.onCustomOptionsEditRow({
              values: { ...row.original, __imageStatus: imageStatus },
              row,
              table,
            });
          }}
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            width: 80,
            height: 80,
            m: 1,
            borderRadius: 2,
            border: `2px dashed ${COLORS.BORDER_DASH}`,
            pointerEvents: isDisabled ? "none" : "auto", // 클릭 막기
            opacity: isDisabled ? 0.5 : 1, // 시각적으로 비활성화 표현
            cursor: isDisabled ? "default" : "pointer",
            "&:hover": {
              backgroundColor: COLORS.HOVER_BACKGROUND,
              borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
          }}
        >
          {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 비율 유지하며 채움
                borderRadius: "inherit", // Box의 borderRadius 따라감
              }}
            />
          ) : (
            <>
              <AddIcon fontSize="medium" />
              <Typography
                sx={{
                  fontFamily: FONT_PROPS.PRIMARY,
                  fontWeight: FONT_PROPS.MEDIUM,
                  color: FONT_PROPS.DARK,
                  fontSize: 15,
                  m: 1,
                }}
              >
                사진등록
              </Typography>
            </>
          )}
        </Box>
      );
    },
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "improve_plan",
    header: "위험성 개선대책 수립",
    size: 220,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      //console.log("row.original", row.original.improve_plan);
      // 테이블에서 사용할 커스텀 텍스트 필드
      const text = row.original.improve_plan || "";
      const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <FormControl sx={{ width: "100%" }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="입력/수정"
            disabled={isDisabled}
            value={text}
            onChange={(e) => {
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, improve_plan: e.target.value },
                row,
                table,
              });
            }}
            multiline // 여러 줄 입력 가능하게 함
            maxRows={2} // 최대 2줄까지 늘어나게 설정 (2줄 이상은 스크롤)
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 14,
              "& .MuiInputBase-input": {
                textAlign: "center", // 텍스트를 가운데 정렬
              },
            }}
          />
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_after_risk",
    header: "개선 후 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.improve_after_risk];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(riskLevelMapper).includes(currentValue)
        ? currentValue
        : "";
      const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            disabled={isDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseRiskLevelMapper[e.target.value] || null;
              //console.log("개선 후 위험성 standard_id:", updatedValue);
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, improve_after_risk: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
            }}
          >
            {/* 메뉴아이템 생성(내림차순) */}
            {Object.entries(riskLevelMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "expected_date",
    header: "개선 예정일",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <FormControl size="small" sx={{ width: 155 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              disabled={isDisabled}
              label={"입력/수정"}
              value={row.original.expected_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, expected_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "emp_id",
    header: "담당자",
    size: 115,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      const empName = row.original.emp_name || "";
      const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <OutlinedInput
          disabled={isDisabled}
          value={empName}
          readOnly
          fullWidth={false}
          sx={{
            fontFamily: FONT_PROPS.PRIMARY,
            fontWeight: FONT_PROPS.MEDIUM,
            color: FONT_PROPS.DARK,
            fontSize: 15,
            width: `${(empName.length + 1) * 2}ch`, // ✅ 글자 수 기반 width
            minWidth: "115px", // 너무 작아지는 것 방지
            height: "56px",
            pointerEvents: "none", // 전체 입력 비활성화
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                disabled={isDisabled}
                onClick={() => {
                  //console.log('검색 클릭')
                  // 검색 클릭 시 처리 로직 추가
                  // 예: 검색 모달 열기
                  table.options?.onCustomOptionsEditRow({
                    values: { ...row.original, __hasSearchEmployee: true },
                    row,
                    table,
                  });
                }}
                edge="end"
                sx={{ pointerEvents: "auto" }} // 아이콘만 클릭 가능하게 허용
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      );
    },
  },
  {
    accessorKey: "improve_status",
    header: "대책상태",
    size: 90,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.improve_status || row.original.improve_status === 0) {
        return strategyStatusRoleMapper[0];
      }
      const improveStatus =
        strategyStatusRoleMapper[row.original.improve_status];
      return improveStatus;
    },
  },
];
// 위험성 개선대책 수립의 담당자 검색 모달 Columns 정의
export const strategyEmpSearchColumns = [
  {
    accessorKey: "emp_id",
    header: "No",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "department_name",
    header: "부서명",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "position_name",
    header: "직급명",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "emp_name",
    header: "성명",
    size: 200,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
];

// 개선대책 실행결과 등록 Columns 정의
export const strategyResultColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 160,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "current_risk_level",
    header: "현재 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_plan",
    header: "위험성 개선대책 수립",
    size: 160,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "improve_after_risk",
    header: "개선후 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.improve_after_risk];
      const text = Object.values(riskLevelMapper).includes(currentValue)
        ? currentValue
        : "";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "expected_date",
    header: "개선예정일",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.expected_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.expected_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
  {
    accessorKey: "improve_before",
    header: "개선전 사진",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table, cell }) => {
      const imageUrl = row.original.improve_before || null;

      const imageStatus = ImageRenderState.EXPAND_BEFORE;
      const isSelectDisabled =
        row.original.register_cause_status === 1 ||
        row.original.process_status === 1 ||
        row.original.register_asset_status === 1;
      return (
        <Box
          onClick={() => {
            if (isSelectDisabled) {
              return;
            }
            //console.log("사진 클릭:", imageUrl);
            // 데이터 업데이트
            table.options?.onCustomOptionsEditRow({
              values: { ...row.original, __imageStatus: imageStatus },
              row,
              table,
            });
          }}
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            width: 80,
            height: 80,
            m: 1,
            borderRadius: 2,
            border: `2px dashed ${COLORS.BORDER_DASH}`,
            pointerEvents: isSelectDisabled ? "none" : "auto", // 클릭 막기
            opacity: isSelectDisabled ? 0.5 : 1, // 시각적으로 비활성화 표현
            cursor: "pointer",
            "&:hover": {
              backgroundColor: COLORS.HOVER_BACKGROUND,
              borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
          }}
        >
          {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 비율 유지하며 채움
                borderRadius: "inherit", // Box의 borderRadius 따라감
              }}
            />
          ) : (
            <>
              <AddIcon fontSize="medium" />
              <Typography
                sx={{
                  fontFamily: FONT_PROPS.PRIMARY,
                  fontWeight: FONT_PROPS.MEDIUM,
                  color: FONT_PROPS.DARK,
                  fontSize: 15,
                  m: 1,
                }}
              >
                사진등록
              </Typography>
            </>
          )}
        </Box>
      );
    },
  },
  {
    accessorKey: "improve_after",
    header: "개선후 사진",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table, cell }) => {
      const imageUrl = row.original.improve_after || null;

      // 개선완료가 되었다면 이미지 확대 로직, 안되었으면 이미지 추가 로직
      const imageStatus =
        row.original.improve_status >= 20 // 20: 개선완료
          ? ImageRenderState.EXPAND_AFTER
          : ImageRenderState.AFTER;
      const isSelectDisabled =
        row.original.register_cause_status === 1 ||
        row.original.process_status === 1 ||
        row.original.register_asset_status === 1;
      return (
        <Box
          onClick={() => {
            if (isSelectDisabled) {
              return;
            }
            //console.log("사진 클릭:", imageUrl);
            // 데이터 업데이트
            table.options?.onCustomOptionsEditRow({
              values: { ...row.original, __imageStatus: imageStatus },
              row,
              table,
            });
          }}
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            width: 80,
            height: 80,
            m: 1,
            borderRadius: 2,
            border: "2px dashed #ccc",
            pointerEvents: isSelectDisabled ? "none" : "auto", // 클릭 막기
            opacity: isSelectDisabled ? 0.5 : 1, // 시각적으로 비활성화 표현
            cursor: "pointer",
            "&:hover": {
              backgroundColor: COLORS.HOVER_BACKGROUND,
              borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
          }}
        >
          {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 비율 유지하며 채움
                borderRadius: "inherit", // Box의 borderRadius 따라감
              }}
            />
          ) : (
            <>
              <AddIcon fontSize="medium" />
              <Typography
                sx={{
                  fontFamily: FONT_PROPS.PRIMARY,
                  fontWeight: FONT_PROPS.MEDIUM,
                  color: FONT_PROPS.DARK,
                  fontSize: 15,
                  m: 1,
                }}
              >
                사진등록
              </Typography>
            </>
          )}
        </Box>
      );
    },
  },
  {
    accessorKey: "comp_date",
    header: "개선완료일",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 개선완료가 된 이후 Select 비활성화 (20: 개선완료)
      const isSelectDisabled =
        row.original.improve_status >= 20 ||
        row.original.register_cause_status === 1 ||
        row.original.process_status === 1 ||
        row.original.register_asset_status === 1;
      return (
        <FormControl
          size="small"
          sx={{ width: "155px", transform: "translateY(-4px)" }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="ko"
            //key={column.accessorKey}
          >
            <DatePicker
              disabled={isSelectDisabled}
              label={"입력/수정"}
              value={row.original.comp_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, comp_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  sx: {
                    marginTop: "16px",
                    marginBottom: "8px",
                  },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_status",
    header: "대책상태",
    size: 90,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.improve_status || row.original.improve_status === 0) {
        return strategyStatusRoleMapper[0];
      }
      const improveStatus =
        strategyStatusRoleMapper[row.original.improve_status];
      return improveStatus;
    },
  },
];
// 개선대책 실행결과 등록 Columns 정의 (관리자 모드 칼럼)
export const strategyResultColumns_admin = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 160,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "공정과 기계/기구",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "current_risk_level",
    header: "현재 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_plan",
    header: "위험성 개선대책 수립",
    size: 220,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      //console.log("row.original", row.original.improve_plan);
      // 테이블에서 사용할 커스텀 텍스트 필드
      const text = row.original.improve_plan || "";
      // const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <FormControl sx={{ width: "100%" }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="입력/수정"
            // disabled={isDisabled}
            value={text}
            onChange={(e) => {
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, improve_plan: e.target.value },
                row,
                table,
              });
            }}
            multiline // 여러 줄 입력 가능하게 함
            maxRows={2} // 최대 2줄까지 늘어나게 설정 (2줄 이상은 스크롤)
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 14,
              "& .MuiInputBase-input": {
                textAlign: "center", // 텍스트를 가운데 정렬
              },
            }}
          />
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_after_risk",
    header: "개선후 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.improve_after_risk];
      // 현재 value가 메뉴에 없으면 공백 처리
      const safeValue = Object.values(riskLevelMapper).includes(currentValue)
        ? currentValue
        : "";
      // const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <FormControl size="small" sx={{ width: "100px" }}>
          <Select
            value={safeValue}
            displayEmpty // value가 ""일 때도 렌더링되게 함
            // disabled={isDisabled}
            onChange={(e) => {
              const updatedValue =
                reverseRiskLevelMapper[e.target.value] || null;
              //console.log("개선 후 위험성 standard_id:", updatedValue);
              // 데이터 업데이트
              table.options?.onCustomOptionsEditRow({
                values: { ...row.original, improve_after_risk: updatedValue },
                row,
                table,
              });
            }}
            sx={{
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
            }}
          >
            {/* 메뉴아이템 생성(내림차순) */}
            {Object.entries(riskLevelMapper)
              .reverse()
              .map(([key, value]) => (
                <MenuItem
                  key={key}
                  value={value}
                  sx={{
                    fontWeight: FONT_PROPS.MEDIUM,
                    color: FONT_PROPS.DARK,
                    fontSize: 15,
                  }}
                >
                  {value}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "expected_date",
    header: "개선예정일",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <FormControl size="small" sx={{ width: 155 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              // disabled={isDisabled}
              label={"입력/수정"}
              value={row.original.__expectedDate || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, __expectedDate: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "improve_before",
    header: "개선전 사진",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table, cell }) => {
      const imageUrl = row.original.improve_before || null;
      const imageStatus = ImageRenderState.BEFORE;
      return (
        <Box
          onClick={() => {
            //console.log("사진 클릭:", imageUrl);
            // 데이터 업데이트
            table.options?.onCustomOptionsEditRow({
              values: { ...row.original, __imageStatus: imageStatus },
              row,
              table,
            });
          }}
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            width: 80,
            height: 80,
            m: 1,
            borderRadius: 2,
            border: `2px dashed ${COLORS.BORDER_DASH}`,
            pointerEvents: "auto", // 클릭 막기
            opacity: 1, // 시각적으로 비활성화 표현
            cursor: "pointer",
            "&:hover": {
              backgroundColor: COLORS.HOVER_BACKGROUND,
              borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
          }}
        >
          {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 비율 유지하며 채움
                borderRadius: "inherit", // Box의 borderRadius 따라감
              }}
            />
          ) : (
            <>
              <AddIcon fontSize="medium" />
              <Typography
                sx={{
                  fontFamily: FONT_PROPS.PRIMARY,
                  fontWeight: FONT_PROPS.MEDIUM,
                  color: FONT_PROPS.DARK,
                  fontSize: 15,
                  m: 1,
                }}
              >
                사진등록
              </Typography>
            </>
          )}
        </Box>
      );
    },
  },
  {
    accessorKey: "improve_after",
    header: "개선후 사진",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table, cell }) => {
      const imageUrl = row.original.improve_after || null;
      const imageStatus = ImageRenderState.AFTER;
      // const isSelectDisabled = row.original.register_cause_status === 1
      //   ||  row.original.process_status === 1
      //   ||  row.original.register_asset_status === 1;
      return (
        <Box
          onClick={() => {
            //console.log("사진 클릭:", imageUrl);
            // 데이터 업데이트
            table.options?.onCustomOptionsEditRow({
              values: { ...row.original, __imageStatus: imageStatus },
              row,
              table,
            });
          }}
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            width: 80,
            height: 80,
            m: 1,
            borderRadius: 2,
            border: "2px dashed #ccc",
            pointerEvents: "auto", // 클릭 막기
            opacity: 1, // 시각적으로 비활성화 표현
            cursor: "pointer",
            "&:hover": {
              backgroundColor: COLORS.HOVER_BACKGROUND,
              borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
          }}
        >
          {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 비율 유지하며 채움
                borderRadius: "inherit", // Box의 borderRadius 따라감
              }}
            />
          ) : (
            <>
              <AddIcon fontSize="medium" />
              <Typography
                sx={{
                  fontFamily: FONT_PROPS.PRIMARY,
                  fontWeight: FONT_PROPS.MEDIUM,
                  color: FONT_PROPS.DARK,
                  fontSize: 15,
                  m: 1,
                }}
              >
                사진등록
              </Typography>
            </>
          )}
        </Box>
      );
    },
  },
  {
    accessorKey: "comp_date",
    header: "개선완료일",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // // 개선완료가 된 이후 Select 비활성화 (20: 개선완료)
      // const isSelectDisabled = row.original.improve_status >= 20
      //   ||  row.original.register_cause_status === 1
      //   ||  row.original.process_status === 1
      //   ||  row.original.register_asset_status === 1;
      return (
        <FormControl size="small" sx={{ width: "155px" }}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="ko"
            //key={column.accessorKey}
          >
            <DatePicker
              // disabled={isSelectDisabled}
              label={"입력/수정"}
              value={row.original.comp_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, comp_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                textField: {
                  // fullWidth: true,
                  sx: { mt: 2, mb: 2 },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "emp_id",
    header: "담당자",
    size: 115,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      const empName = row.original.emp_name || "";
      const isDisabled = !row.original?.improve_status; // 수립 대기는 수정 불가
      return (
        <OutlinedInput
          disabled={isDisabled}
          value={empName}
          readOnly
          fullWidth={false}
          sx={{
            fontFamily: FONT_PROPS.PRIMARY,
            fontWeight: FONT_PROPS.MEDIUM,
            color: FONT_PROPS.DARK,
            fontSize: 15,
            width: `${(empName.length + 1) * 2}ch`, // ✅ 글자 수 기반 width
            minWidth: "115px", // 너무 작아지는 것 방지
            height: "56px",
            pointerEvents: "none", // 전체 입력 비활성화
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                disabled={isDisabled}
                onClick={() => {
                  //console.log('검색 클릭')
                  // 검색 클릭 시 처리 로직 추가
                  // 예: 검색 모달 열기
                  table.options?.onCustomOptionsEditRow({
                    values: { ...row.original, __hasSearchEmployee: true },
                    row,
                    table,
                  });
                }}
                edge="end"
                sx={{ pointerEvents: "auto" }} // 아이콘만 클릭 가능하게 허용
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      );
    },
  },
  {
    accessorKey: "improve_status",
    header: "대책상태",
    size: 90,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.improve_status || row.original.improve_status === 0) {
        return strategyStatusRoleMapper[0];
      }
      const improveStatus =
        strategyStatusRoleMapper[row.original.improve_status];
      return improveStatus;
    },
  },
];

// 위험성 감소대책 일정관리 Columns 정의 (현재 페이지 합쳐서 사용 안함)
export const strategyScheduleColumns = [
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 200,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    //accessorKey: "asset_name",
    header: "설비명",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
  },
  {
    accessorKey: "current_risk_level",
    header: "현재 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "eval_date",
    header: "평가일자",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.eval_date) {
        return "-";
      }
      //const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD HH:mm:ss");
      const formattedTime = dayjs(row.original.eval_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "improve_plan",
    header: "위험성 감소대책",
    size: 200,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "improve_after_risk",
    header: "개선후 위험성",
    size: 100,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.improve_after_risk];
      const text = Object.values(riskLevelMapper).includes(currentValue)
        ? currentValue
        : "";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "expected_date",
    header: "개선 예정일",
    size: 155,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      // 일정 등록이 된 이후 Select 비활성화
      const isSelectDisabled = row.original.improve_status >= 20;
      return (
        <FormControl
          size="small"
          sx={{ width: "155px", transform: "translateY(-4px)" }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="ko"
            //key={column.accessorKey}
          >
            <DatePicker
              disabled={isSelectDisabled}
              label={"입력/수정"}
              value={row.original.expected_date || null}
              onChange={(e) => {
                //console.log("개선 예정일:", e);
                // 데이터 업데이트
                table.options?.onCustomOptionsEditRow({
                  values: { ...row.original, expected_date: e },
                  row,
                  table,
                });
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  sx: { marginTop: "16px", marginBottom: "8px" },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      );
    },
  },
  {
    accessorKey: "emp_id",
    header: "담당자",
    size: 115,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      const empName = row.original.emp_name || "";
      // 일정 등록이 된 이후 Select 비활성화
      const isSelectDisabled = row.original.improve_status >= 20;
      return (
        <OutlinedInput
          disabled={isSelectDisabled}
          value={empName}
          readOnly
          fullWidth={false}
          sx={{
            fontFamily: FONT_PROPS.PRIMARY,
            fontWeight: FONT_PROPS.MEDIUM,
            color: FONT_PROPS.DARK,
            fontSize: 15,
            width: `${(empName.length + 1) * 2}ch`, // ✅ 글자 수 기반 width
            minWidth: "115px", // 너무 작아지는 것 방지
            height: "56px",
            pointerEvents: "none", // 전체 입력 비활성화
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                disabled={isSelectDisabled}
                onClick={() => {
                  //console.log('검색 클릭')
                  // 검색 클릭 시 처리 로직 추가
                  // 예: 검색 모달 열기
                  table.options?.onCustomOptionsEditRow({
                    values: { ...row.original, hasSearchEmployee: true },
                    row,
                    table,
                  });
                }}
                edge="end"
                sx={{ pointerEvents: "auto" }} // 아이콘만 클릭 가능하게 허용
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      );
    },
  },
  {
    accessorKey: "improve_status",
    header: "대책상태",
    size: 80,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    Cell: ({ row, table }) => {
      if (!row.original.improve_status || row.original.improve_status === 0) {
        return strategyStatusRoleMapper[0];
      }
      const improveStatus =
        strategyStatusRoleMapper[row.original.improve_status];
      return improveStatus;
    },
  },
];

//----------------------------------------

////////////////////////////////
// 모니터링
////////////////////////////////

// 위험성 평가 결과의 평가 미완료 상세정보 Columns 정의
export const monitoringResultMonthlyInfoColumns = [
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_description",
    header: "공정 내용",
    size: 350,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_cause",
    header: "위험원인",
    size: 180,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 450,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "대상 기계/기구",
    type: "text",
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "delete_date",
    header: "삭제일자",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.register_cause_delete_date) return "-";

      const formattedTime = dayjs(row.register_cause_delete_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
];

// 대책수립 결과의 개선 미완료 상세정보 Columns 정의
export const monitoringStrategyMonthlyInfoColumns = [
  {
    accessorKey: "process_name",
    header: "공정명",
    size: 150,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "process_description",
    header: "공정내용",
    size: 300,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_category",
    header: "위험분류",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_cause",
    header: "위험원인",
    size: 180,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "danger_description",
    header: "위험요인 발생상황 및 결과",
    size: 360,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_name",
    header: "대상 기계/기구",
    type: "text",
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      const masterMachineName = row.machine_name;
      const safeMachineName = row.safe_machine_name;
      let name = masterMachineName;
      if (safeMachineName || safeMachineName !== "") {
        name = safeMachineName;
      }
      return name;
    },
    Cell: ({ cell, table }) => {
      const text = cell.getValue();
      const globalFilter = table.getState().globalFilter || "";

      return <HighlightedText text={text} globalFilter={globalFilter} />;
    },
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "machine_manage_code",
    header: "관리번호",
    type: "text",
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "current_risk_level",
    header: "현재 위험성",
    size: 100,
    type: "text",
    Cell: ({ row, table }) => {
      // 테이블에서 사용할 커스텀 셀 컴포넌트(Select)
      const currentValue = riskLevelMapper[row.original.standard_id];
      const text = currentValue
        ? `${currentValue}(${
            row.original.frequency_level * row.original.importancy_level
          })`
        : "-";
      return (
        <FormControl>
          <Typography
            sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              fontSize: 15,
              backgroundColor: RISK_LEVEL_COLOR_MAP[currentValue],
              border: currentValue
                ? `1px solid ${COLORS.BORDER_BRIGHT}`
                : "none",
              borderRadius: "4px",
              //padding: "8px 16px 8px 16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              height: "40px",
            }}
          >
            {text}
          </Typography>
        </FormControl>
      );
    },

    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
  },
  {
    accessorKey: "expected_date",
    header: "대책수립일자",
    size: 120,
    type: "text",
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.expected_date) return "-";

      const formattedTime = dayjs(row.expected_date).format("YYYY-MM-DD");
      return formattedTime;
    },
  },
  {
    accessorKey: "delete_date",
    header: "삭제일자",
    type: "text",
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableBodyCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    muiTableFooterCellProps: {
      align: "center",
      // sx: { width: "50px", minWidth: "50px", maxWidth: "70px !important" },
    },
    accessorFn: (row) => {
      // 글로벌 필터에도 검색이 되게 accessorFn으로 설정함
      if (!row.register_cause_delete_date) return "-";

      const formattedTime = dayjs(row.register_cause_delete_date).format(
        "YYYY-MM-DD"
      );
      return formattedTime;
    },
  },
];

//----------------------------------------

////////////////////////////////
// Helper
////////////////////////////////

// 위험성 수준 판단 기준 가능성(빈도)의 Role Mapper 정의
export const frequencyLevelRoleMapper = {
  1: "최하",
  2: "하",
  3: "중",
  4: "상",
  5: "최상",
};
const reverseFrequencyLevelRoleMapper = {
  최하: 1,
  하: 2,
  중: 3,
  상: 4,
  최상: 5,
};

// 위험성 수준 판단 기준 중대성(강도)의 Role Mapper 정의
export const importancyLevelRoleMapper = {
  1: "소",
  2: "중",
  3: "대",
  4: "최대",
};
const reverseImportancyLevelRoleMapper = {
  소: 1,
  중: 2,
  대: 3,
  최대: 4,
};

// 위험성 허용 기준의 Role Mapper 정의
export const riskLevelMapper = {
  1: "매우낮음",
  2: "낮음",
  3: "보통",
  4: "약간높음",
  5: "높음",
  6: "매우높음",
};
const reverseRiskLevelMapper = {
  매우낮음: 1,
  낮음: 2,
  보통: 3,
  약간높음: 4,
  높음: 5,
  매우높음: 6,
};

// 위험성 허용 기준의 색상 맵핑
const RISK_LEVEL_COLOR_MAP = {
  매우낮음: "#D5FFD5",
  낮음: "#B8FFB8",
  보통: "#FBFF00",
  약간높음: "#FFD5B8",
  높음: "#FF9900",
  매우높음: "#FF4444",
};

// 평가상태 Role Mapper 정의
const evalStatusRoleMapper = {
  0: "평가대기",
  10: "평가완료",
  20: "승인완료",
};

// 대책상태 Role Mapper 정의
const strategyStatusRoleMapper = {
  0: "등록대기",
  10: "등록완료",
  20: "개선완료",
};

// 개선 전.후 이미지 렌더 상태 정의
export const ImageRenderState = Object.freeze({
  NONE: "none", // 기본값
  BEFORE: "improve_before", // 개선 전 사진
  AFTER: "improve_after", // 개선 후 사진
  EXPAND_BEFORE: "expand_before_image", // 개선전 사진 확대
  EXPAND_AFTER: "expand_after_image", // 개선후 사진 확대
});

// 삭제 항목 배경색
const deleteBackground = {
  backgroundColor: "#ffebeb", // 연한 빨간색 배경
  backgroundImage:
    "repeating-linear-gradient(45deg, #ffcccc 0, #ffcccc 2px, transparent 2px, transparent 6px)",
  backgroundSize: "8px 8px",
};

// 하이라이트 처리 컴포넌트
const HighlightedText = ({ text, globalFilter }) => {
  if (!globalFilter || typeof text !== "string") {
    return text;
  }

  // 하이라이트 처리: 글로벌 필터에 해당하는 부분만 mark로 감싸기
  const parts = text.split(new RegExp(`(${globalFilter})`, "gi"));

  return (
    <span>
      {parts.map((part, index) =>
        part.toLowerCase() === globalFilter.toLowerCase() ? (
          <mark key={index}>{part}</mark>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </span>
  );
};
